// extracted by mini-css-extract-plugin
export default {"BackdropScreen":"BackdropScreen_BackdropScreen__lYh78"};